// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"SubscriptionList_tableHeader_1gMDp","elipseColor":"SubscriptionList_elipseColor_MpFh6"};